import type { z } from 'zod'

export const refineUniqueIds = <Field extends string, IdKey extends string>(
  value: Readonly<Record<Field, readonly Readonly<Record<IdKey, number>>[]>>,
  ctx: z.RefinementCtx,
  field: Field,
  idKey: IdKey,
  message: string
): void => {
  const items = value[field]
  const seen = new Map<number, number>()
  items.forEach((item) => seen.set(item[idKey], (seen.get(item[idKey]) ?? 0) + 1))
  items.forEach((item, index) => {
    if ((seen.get(item[idKey]) ?? 0) > 1) {
      ctx.addIssue({ code: 'custom', message, path: [field, index, idKey] })
    }
  })
}
